import { createRouter, createWebHistory } from 'vue-router';

import NotFoundPage from '@/pages/guest/NotFoundPage/NotFoundPage.vue';
// Guest Pages
import SalePage from '@/pages/guest/SalePage/SalePage.vue';
import FormPage from '@/pages/guest/FormPage/FormPage.vue';
import AgentFormPage from '@/pages/guest/AgentFormPage/AgentFormPage.vue';
import ShortFormPage from '@/pages/guest/ShortFormPage/ShortFormPage.vue';
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 60 };
    return { top: 0 };
  },
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes: [
    {
      path: '/',
      name: 'Sale Page',
      component: SalePage
    },
    {
      path: '/phone',
      name: 'Phone Page',
      component: SalePage
    },
    {
      path: '/short-form/:id',
      name: 'Short Form Page',
      component: ShortFormPage
    },
    {
      path: '/form/:id',
      name: 'Form Page',
      component: FormPage
    },
    {
      path: '/agent-form/:id',
      name: 'Agent Form Page',
      component: AgentFormPage
    },
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundPage
    }
  ]
});
export default router;
